import {
  handleAxiosError,
  urlBackend,
} from '@/shared';
import { erpApi } from '@/shared/axios/erp-api';
import { AlertSeverityEnum, Cliente, UseMutationsParams } from '@/shared/interfaces';
import {
  IDataCedula,
  IDataRuc,
  IDatosPersona,
} from '@/shared/interfaces/erp/prospecto';
import { useUiStore } from '@/store/ui';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios, { isAxiosError } from 'axios';
import { toast } from 'react-toastify';

const { post: postErpApi } = erpApi();

type IIdentificationCedulaProps = {
  identificacion: string;
  verificar_cliente?: boolean;
  es_corporativo?: boolean;
  es_pymes?: boolean;
};

interface IdentificadorParams extends UseMutationsParams {
  identificacion?: string;
  tiene_prospecto?: string;
  es_pymes?: boolean
}

//OBTENER DATOS POR LA CEDULA
export const useFetchSearchIdentification = ({
  enableSuccessAlert = true,
  customSuccessMessage,
}: IdentificadorParams = {}) => {
  const queryClient = useQueryClient();
  const setAlert = useUiStore.getState().setAlert;
  //const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;

  return useMutation({
    mutationFn: searchDataByCedula,
    onSuccess: d => {
      queryClient.invalidateQueries({ queryKey: ['identificationCedula'] });

      if (d.code == 202) {
        toast.info('Nota: El cliente tiene deudas acumuladas.')
      }

      if (d.code != 200 && d.code != 201) {
        setAlert(true, d.message, d.status);
        return;
      }

      enableSuccessAlert &&
        setAlert(true, customSuccessMessage ?? d.message, d.status);
    },
    onError: error => {
      console.log('error', error);

      if (isAxiosError(error)) {

        const respError: any = error?.response?.data || {};

        switch (respError.code) {
          case 409:
            if (respError.prospectos_corporativos_user_create
              && respError.prospectos_corporativos_user_create.length > 0
            ) {
              return setAlert(true, 'Cliente con vendedor asignado.', AlertSeverityEnum.info);
            }
            return setAlert(true, 'Existe una venta en proceso.', AlertSeverityEnum.info);
          case 400:
            respError.code = 500;
            respError.message = 'Hubo un inconveniente al obtener los datos del registro civil con la identificación. Por favor, inténtalo nuevamente más tarde.';
            handleAxiosError(error)
            break;
          case 408:
            return setAlert(true, 'Identificación no válida. Corresponde a una persona fallecida o no existe.', AlertSeverityEnum.error);
          default:
            handleAxiosError(error)
            break;
        }
      }
    },
    onSettled: () => {
      //setIsGlobalLoading(false);
    },
    gcTime: 2000
  });
};

export const searchDataByCedula = async (data: IIdentificationCedulaProps) => {
  /* const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
  setIsGlobalLoading(true); */

  const res = await postErpApi<IDataCedula>(
    `${urlBackend}api/v1/obtener-datos-identificacion/`,
    data,
    true
  );
  return res;
};

///* Obtener informacion de la persona sin validaciones


export const useFetchSearchIdentificationDirecto = ({
  enableSuccessAlert = true,
  customSuccessMessage,
}: IdentificadorParams = {}) => {
  const queryClient = useQueryClient();
  const setAlert = useUiStore.getState().setAlert;
  //const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;

  return useMutation({
    mutationFn: searchDataByCedulaDirecto,
    onSuccess: d => {
      queryClient.invalidateQueries({ queryKey: ['identificationCedula'] });

      if (d.code == 202) {
        toast.info('Nota: El cliente tiene deudas acumuladas.')
      } else {
        enableSuccessAlert &&
          setAlert(true, customSuccessMessage ?? d.message, d.status);
      }



    },
    onError: error => {
      handleAxiosError(error)
    },
    onSettled: () => {
      //setIsGlobalLoading(false);
    },
    gcTime: 2000
  });
};

export const searchDataByCedulaDirecto = async (data: IIdentificationCedulaProps) => {

  const res = await postErpApi<IDataCedula>(
    `${urlBackend}api/v1/obtener-datos-identificacion-directo/`,
    data,
    true
  );
  return res;
};


//FUNCION TEMPORAL PARA EL NUMERO DE CEDULA
export async function fetchDataCedula(dataToSend: any): Promise<IDatosPersona> {
  try {
    let headersList = {};

    let formdata = new FormData();
    formdata.append('ced_id', dataToSend);
    let bodyContent = formdata;
    let reqOptions = {
      url: 'https://sib.ambiente.gob.ec/registro/registrosib/identidad',
      method: 'POST',
      headers: headersList,
      data: bodyContent,
    };
    let response = await axios.request(reqOptions);

    // Devuelve la respuesta de la API
    return response.data;
  } catch (error) {
    // Si ocurre un error, maneja la excepción aquí

    throw error;
  }
}

//OBTENER DATOS POR RUC
type IIdentificationRUCProps = {
  ruc: string;
};

export const useSearchDataByIdentificationRUC = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: searchDataByRuc,
    onSuccess: d => {
      const setAlert = useUiStore.getState().setAlert;
      queryClient.invalidateQueries({ queryKey: ['identificationRuc'] });
      if (d.code != 200) setAlert(true, d.message, d.status);
    },
  });
};

export const searchDataByRuc = async (data: IIdentificationRUCProps) => {
  const res = await postErpApi<IDataRuc>(
    `${urlBackend}api/v1/consulta-api/obtener-datos-ruc/`,
    data,
    true
  );
  return res;
};

//ES CLIENTE DE FIBRAMAX

type IIdentificationEsClienteProps = {
  identificacion: string;
};

export const useFetchEsClienteFibramax = () => {
  const setAlert = useUiStore.getState().setAlert;
  return useMutation({
    mutationFn: postEsClienteFibramax,
    onSuccess: d => {
      return setAlert(true, d.message, d.status);
    },
    onError: error => {
      if (isAxiosError(error)) {

        if (error.code == 'ERR_BAD_RESPONSE')
          return setAlert(true, 'Cliente no encontrado en el sistema.', AlertSeverityEnum.warning)

      }
      handleAxiosError(error);
    },
  });
};

export const postEsClienteFibramax = async (
  data: IIdentificationEsClienteProps
) => {
  const res = await postErpApi<Cliente>(
    `${urlBackend}api/v1/cliente-identificacion/`,
    data,
    true
  );
  return res;
};
